import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { loadBranded } from '../utils/bootstrap';
import { readPreviewVariant, resolveHomeVariant } from '../pages/Home/variants';

// Is the site on the "Airbnb Pro" home design? Its site chrome (phone bottom
// bar, footer) follows it; every other design keeps its own chrome exactly.
// A ?preview_design= look at the home page carries on to the pages opened
// from it in that tab, so the chrome doesn't flip back mid-preview.
export const readProDesign = () => {
    let v = readPreviewVariant();
    try {
        if (v) sessionStorage.setItem('hm_preview_nav', v);
        else if (window.location.pathname !== '/') v = sessionStorage.getItem('hm_preview_nav') || '';
        else sessionStorage.removeItem('hm_preview_nav');
    } catch { /* storage blocked — the real setting still applies */ }
    return (v || resolveHomeVariant(loadBranded('hm_hero_banner', 'hero', {})?.homeVariant)) === 'bnbpro';
};

export default function useProDesign() {
    const { pathname } = useLocation();
    const [pro, setPro] = useState(readProDesign);
    useEffect(() => {
        const refresh = () => setPro(readProDesign());
        refresh();
        window.addEventListener('hm-settings-loaded', refresh);
        return () => window.removeEventListener('hm-settings-loaded', refresh);
    }, [pathname]);
    return pro;
}
